
document.addEventListener('DOMContentLoaded', (event) => {
	$('.right-side .search-link').on('click', function () {
		$('.search-pull-out').addClass('show-search');
		$('.search-pull-out input').focus();
	});

	$('.lnr.lnr-cross.exit-search').on('click', function () {
		$('.search-pull-out').removeClass('show-search');
	});
});

$(window).on('load', function () {
	// Animate loader off screen
	$("#loading-screen").fadeOut(500);
});

function msieversion() {
		var ua = window.navigator.userAgent;
		var msie = ua.indexOf("MSIE ");
		if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {  // If Internet Explorer, return version number
		$('.help-trigger').hide();
				return (ua.substring(msie + 5, ua.indexOf(".", msie)));
		} else // If another browser, return 0
		{
				return 'otherbrowser';
		}
		return false;
}
